import StyleBase from '../../../styles/base';

const styles: any = {
  androidButton: {
    backgroundImage: 'url(/static/img/home/google_play.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'block',
    height: 55,
    textIndent: -99999,
    width: 186,
    [StyleBase.media.mobile]: {
      height: 48,
      width: 164,
    },
  },
  appButtonsContainer: {
    margin: '0 auto 30px',
    maxWidth: 390,
    position: 'relative',
    zIndex: 1,
    [StyleBase.media.mobile]: {
      maxWidth: '180px !important',
    },
  },
  appButtonsLink: {
    marginTop: 0,
  },
  getStarted: {
    MozAnimation: 'AnimateBackground 45s ease infinite',
    WebkitAnimation: 'AnimateBackground 45s ease infinite',
    animation: 'AnimateBackground 45s ease infinite',
    background:
      'radial-gradient(circle, #ffeaa0 0%, #ff985d 50%, #6b4bcf 100%)',
    backgroundSize: '200% 200%',
    color: 'white',
    height: 690,
    paddingBottom: 30,
    position: 'relative',
    width: '100%',
    [StyleBase.media.mobile]: {
      height: 610,
    },
    [StyleBase.media.tablet]: {
      height: 630,
    },
  },
  getStartedHeader: {
    color: 'white',
    fontSize: 64,
    fontWeight: 500,
    lineHeight: '77px',
    margin: '0 auto',
    [StyleBase.media.tablet]: {
      fontSize: 48,
    },
    [StyleBase.media.mobile]: {
      fontSize: 40,
    },
  },
  getStartedTopper: {
    backgroundImage: 'url("/static/img/home/cta_topper.png")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    height: 37,
    position: 'absolute',
    top: 0,
    width: '100%',
    [StyleBase.media.mobile]: {
      backgroundImage: 'url("/static/img/home/cta_topper_sm.png")',
      backgroundSize: '100% 22px',
    },
  },
  houseIcon: {
    height: 250,
    margin: '0 auto',
    position: 'relative',
    width: 581,
    [StyleBase.media.tablet]: {
      height: 155,
      width: 359,
    },
    [StyleBase.media.mobile]: {
      height: 155,
      width: 359,
    },
  },
  houseIconContainer: {
    bottom: 310,
    left: 0,
    position: 'absolute',
    width: '100%',
    [StyleBase.media.tablet]: {
      bottom: 320,
    },
    [StyleBase.media.mobile]: {
      bottom: 392,
    },
  },
  inner: {
    position: 'relative',
    width: '100%',
    zIndex: 1,
    [StyleBase.media.tablet]: {
      top: -20,
    },
    [StyleBase.media.mobile]: {
      paddingBottom: 50,
      top: 15,
    },
  },
  iosButton: {
    backgroundImage: 'url(/static/img/home/apple.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'block',
    height: 55,
    textIndent: -99999,
    width: 164,
    [StyleBase.media.mobile]: {
      marginBottom: 10,
    },
  },
  lawnContainer: {
    bottom: 0,
    height: 350,
    left: 0,
    overflow: 'hidden',
    position: 'absolute',
    width: '100%',
    [StyleBase.media.tablet]: {
      height: 350,
    },
    [StyleBase.media.mobile]: {
      height: 420,
    },
  },
  lawnInner: {
    height: '100%',
    width: '100%',
    [StyleBase.media.tablet]: {
      left: '-40%',
      position: 'absolute',
      top: 0,
      width: '180%',
    },
    [StyleBase.media.mobile]: {
      left: '-15%',
      position: 'absolute',
      top: 0,
      width: '130%',
    },
  },
  subHeader: {
    color: 'white',
    fontSize: 24,
    fontWeight: 300,
    lineHeight: '32px',
    marginBottom: 30,
    marginTop: 12,
    textAlign: 'center',
    textShadow: '0 2px 5px rgba(0, 0, 0, 0.25)',
    [StyleBase.media.tablet]: {
      fontSize: 18,
      lineHeight: '25px',
      marginTop: 0,
    },
    [StyleBase.media.mobile]: {
      fontSize: 16,
      lineHeight: '25px',
      margin: '0 auto 25px !important',
      maxWidth: '90%',
    },
  },
};

export default styles;
